// Trial Balance State

export default {
  trialBalanceList: []
}
